import Vue from 'vue';
import VDraggable from 'vue-sortable-list';

Vue.use(VDraggable);
